import { useEffectOnce } from 'react-use';
import cns from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { logger } from '@zep/core-logger';
import { Language } from '@zep/types';
import AssetIntroduce from '../../components/service/stores/StoreDetail/AssetIntroduce';
import AssetSummary from '../../components/service/stores/StoreDetail/AssetSummary';
import StoreReviewLayout from '../../components/service/stores/StoreReview/StoreReviewLayout';
import { StoreCategoryName, StoreReviewState } from '../../consts';
import { useStoreItemDetail, useStoreItemReviews } from '../../services';
import S from './Store.module.scss';
export const StoreDetailsPageView = () => {
  const router = useRouter();
  const {
    user
  } = useAuth();
  const {
    t
  } = useTranslation(['store']);
  const assetHashId = `${router.query.id}`;
  const assetDetails = useStoreItemDetail(assetHashId, router.locale as Language, !!user?.isEdu);
  const reviewData = useStoreItemReviews(assetHashId, 1, !!user?.isEdu);
  useEffectOnce(() => {
    if (assetDetails.isSuccess) {
      // 주의: 최초 한번 이 앰플리튜드 코드가 실행되어야 하므로, effect deps 를 비워야 합니다.
      logger.track('store_detail', {
        type: StoreCategoryName[assetDetails.data?.item.category ?? 0],
        name: assetDetails.data?.item.name
      });
    }
  });
  if (!assetDetails.isSuccess || !reviewData.isSuccess) {
    return <></>;
  }
  return <>
      {assetDetails.data.item.status === StoreReviewState.required && <div className={S.asset_audit_banner}>
          <label>{t('store:store_judge_asset_description')}</label>
        </div>}
      {assetDetails.data.item.status === StoreReviewState.rejected && <div className={S.asset_audit_banner}>
          <label>{t('store:store_asset_register_denied')}</label>
        </div>}
      <div className={cns(S.details_container, S.no_margin)}>
        <div className={S.details_wrapper}>
          <AssetIntroduce assetHashId={assetHashId} data-sentry-element="AssetIntroduce" data-sentry-source-file="details.tsx" />
          <StoreReviewLayout assetHashId={assetHashId} data-sentry-element="StoreReviewLayout" data-sentry-source-file="details.tsx" />
        </div>
        <div className={S.asset_summary_wrapper}>
          <AssetSummary assetHashId={assetHashId} data-sentry-element="AssetSummary" data-sentry-source-file="details.tsx" />
        </div>
      </div>
    </>;
};